/* Renk Sahnesi — kitap bulucu (sections/rs-finder.liquid). Saf JS, bağımlılık yok.

   Sıralama:
     1. Yaş bir süzgeçtir: yaş seçildiyse yalnız o yaş etiketini taşıyan ürünler önerilir.
     2. Kalanlar puanlanır: konu etiketi tutuyorsa +4, bütçe tutuyorsa +2. Konu bütçeden
        önce gelir; bütçeyi aşan kitap elenmez, kartında ne kadar aştığı yazar ve aynı
        puandakiler arasında bütçeye en yakın olan öne geçer. Bütçeye uyan kitap varsa
        listede en az biri bulunur (konusu tutmasa da, sona eklenir; not bunu söyler).
     3. Eşit puanda seçilen yaşa daha iyi uyan (ürünün yaş aralığının ne kadarı seçilen yaşın içinde),
        sonra koleksiyondaki yer (ayar), o da yoksa ucuz olan öne geçer.
     4. Sonuçta en çok bir set / hediyelik paket olur ("Set olsun" bütçesinde birden çok set
        olabilir, yalnız aynı kitabı içeren iki set yan yana gelmez); setin içindeki tek kitaplar
        (adı setin adında ya da custom.set_icerigi'nde geçenler) yanına önerilmez.
        Konu eşleşmesi yokken aynı seriden ya da aynı kalıptan (yayınevi + ebat) ikinci
        kitap yerine başkası denenir.
   Uygulama üyelikleri (tip-uygulama) veri yüklenirken ayıklanır; ne sayaçta ne sonuçta görünür.
   "Kendim için" (yalnız yas-ebeveyn) seçilince konu sorusu atlanır: ebeveyn kitaplarında
   konu etiketi yoktur.

   Yanıtlar sessionStorage'da tutulur: ürün sayfasına gidip geri dönen, sorulara yeniden
   başlamaz (geri/ileri önbelleği olmayan uygulama içi tarayıcılar için).

   Sepete ekleme bu dosyada değildir: sonuç düğmeleri data-op-add / data-op-add-many taşır,
   isteği assets/oyunperest.js gönderir. Bu dosya 'op:cart' olayıyla gelen sepeti (detail.cart) okur:
   sepetteki kitabın düğmesi "Sepette" işaretine döner (ikinci adet yanlışlıkla eklenmez),
   toplu düğme yalnız sepette olmayanları toplar ve sonuçların altına kalıcı "Sepete git"
   satırı gelir. Tek birincil eylem: sepet boşken toplu düğme, doluyken "Sepete git".

   Toplu düğme bütçeye uyar: tek kitap bütçesinde (b1) çıkmaz; ikinci bantta (b2) yalnız
   bütçeyi aşmayan ve toplamı üst sınırı geçmeyen kitapları ekler. */
(function () {
  'use strict';

  var ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) { return ESCAPES[c]; });
  }

  function fill(text, values) {
    return String(text || '').replace(/\[\[(\w+)\]\]/g, function (all, key) {
      return values[key] == null ? '' : values[key];
    });
  }

  function has(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
  }

  function readJson(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  /* HTML'den düz metin: etiketler boşluğa döner, &amp; gibi varlıklar çözülür */
  var decoder;
  function plain(html) {
    decoder = decoder || document.createElement('textarea');
    decoder.innerHTML = String(html || '').replace(/<[^>]*>/g, ' ');
    return decoder.value.replace(/\s+/g, ' ').trim();
  }

  /* Kart altındaki tek satır: ürünün alt başlığı. Açıklamadan türetilmez (bağlantı,
     seri tanıtımı, yazar özgeçmişi gibi artıklar çıkıyordu); boşsa satır hiç yazılmaz. */
  function summarize(text) {
    var out = plain(text);
    if (out.length > 110) out = out.slice(0, 107).replace(/\s\S*$/, '') + '…';
    return out;
  }

  /* Ad karşılaştırması için: küçük harf, yalnız harf ve rakam */
  var NOT_WORD;
  try {
    NOT_WORD = new RegExp('[^\\p{L}\\p{N}]+', 'gu');
  } catch (error) {
    NOT_WORD = /[^0-9a-zçğıöşüâîû]+/g;
  }
  function wordKey(text) {
    return String(text || '').toLocaleLowerCase('tr').replace(NOT_WORD, ' ').trim();
  }

  /* Mağazanın para biçimiyle yazar; kuruş yoksa ondalık atılır (Liquid'deki
     money_without_trailing_zeros ile aynı görünüm). */
  function money(cents, format) {
    var match = /\{\{\s*(\w+)\s*\}\}/.exec(format || '');
    var kind = match ? match[1] : 'amount';
    var thousands = ',';
    var decimal = '.';
    if (kind.indexOf('period_and_space') !== -1) {
      thousands = ' ';
    } else if (kind.indexOf('comma_separator') !== -1) {
      thousands = '.';
      decimal = ',';
    } else if (kind.indexOf('space_separator') !== -1) {
      thousands = ' ';
      decimal = ',';
    } else if (kind.indexOf('apostrophe') !== -1) {
      thousands = "'";
    }
    var parts = (cents / 100).toFixed(kind.indexOf('no_decimals') !== -1 ? 0 : 2).split('.');
    var out = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    if (parts[1] && parts[1] !== '00') out += decimal + parts[1];
    return (match ? format.replace(match[0], out) : out).trim();
  }

  /* Seçenek satırı: Etiket | etiket-değeri | not */
  function parseOptions(text) {
    return String(text || '')
      .split('\n')
      .map(function (line) {
        var p = line.split('|');
        return {
          label: (p[0] || '').trim(),
          value: (p[1] || '').trim(),
          note: (p[2] || '').trim(),
        };
      })
      .filter(function (o) { return o.label; });
  }

  function tagList(value) {
    return String(value || '')
      .split(/[|,]/)
      .map(function (t) { return t.trim(); })
      .filter(Boolean);
  }

  function hasAny(product, tags) {
    return tags.some(function (t) { return product.tags.indexOf(t) !== -1; });
  }

  var SET_TAGS = ['tip-set', 'tip-hediyelik'];
  var PARENT_TAG = 'yas-ebeveyn';

  /* bands: { b1, b2 } lira cinsinden üst sınırlar (bölüm ayarı) */
  function budgetFits(product, budget, bands) {
    var lira = product.price / 100;
    if (budget === 'b1') return lira <= bands.b1;
    if (budget === 'b2') return lira > bands.b1 && lira <= bands.b2;
    if (budget === 'b3') return !!product.set;
    return false;
  }

  /* Seçilen bandın üst sınırını kaç kuruş aştığı; sınırın içinde ve "set olsun"da 0 */
  function budgetOver(product, budget, bands) {
    var max = budget === 'b1' ? bands.b1 : budget === 'b2' ? bands.b2 : 0;
    return max && product.price > max * 100 ? product.price - max * 100 : 0;
  }

  /* Tek kitap bu setin içinde mi: adı setin adında ya da içerik listesinde geçiyorsa evet */
  function holds(set, single) {
    return single.key.length > 3 && set.hay.indexOf(' ' + single.key + ' ') !== -1;
  }

  function sized(src, width) {
    if (!src) return '';
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$1' + width);
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  var SAFE_COLOR = /^(#[0-9a-f]{3,8}|rgba?\([\d\s.,%]+\))$/i;
  var SAFE_NUM = /^\d*\.?\d+$/;

  /* Bulucu kökleri: sepet olayı belge düzeyinde bir kez dinlenir, açık köklere dağıtılır
     (tema düzenleyicisi bölümü yeniden çizdiğinde dinleyici birikmesin) */
  /* oyunperest.js her sepet değişiminde /cart.js'i bir kez okur ve sonucu 'op:cart' olayıyla
     (detail.cart) yayar: bulucu ikinci bir istek atmaz. */
  var finders = [];
  document.addEventListener('op:cart', function (event) {
    var cart = event.detail && event.detail.cart;
    if (!cart) return;
    finders = finders.filter(function (r) { return r.isConnected; });
    finders.forEach(function (r) {
      if (r.rsFinderOnCart) r.rsFinderOnCart(cart);
    });
  });
  var KEEP_MS = 30 * 60 * 1000; /* saklanan yanıtlar yarım saat sonra geçersiz */

  function init(root) {
    if (root.rsFinderReady) return;
    root.rsFinderReady = true;

    var cfg = readJson(root.querySelector('[data-rs-finder-config]'));
    var screen = root.querySelector('[data-rs-finder-screen]');
    if (!cfg || !screen) return;

    /* Çeviri süzgeci metni HTML için kaçırır (&quot; gibi); burada bir kez çözülür,
       ekrana yazarken esc() yeniden kaçırır. */
    var T = cfg.t || {};
    Object.keys(T).forEach(function (name) {
      if (typeof T[name] === 'string') T[name] = plain(T[name]);
    });

    var sectionId = root.getAttribute('data-rs-finder') || 'x';
    var uid = 'rs-finder-' + sectionId;
    var storeKey = 'rs-finder:' + sectionId;
    var limit = Number(cfg.limit) || 3;
    var appTag = cfg.appTag || 'tip-uygulama';
    var bands = { b1: Number(cfg.b1Max) || 150, b2: Number(cfg.b2Max) || 400 };
    if (bands.b2 < bands.b1) bands.b2 = bands.b1;
    var cartUrl = cfg.cartUrl || '/cart';
    var card = root.querySelector('[data-rs-finder-card]') || root;
    var stepsEl = root.querySelector('[data-rs-finder-steps]');
    var live = root.querySelector('[data-rs-finder-live]');
    var mail = root.querySelector('[data-rs-finder-mail]');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Eşit puanda sıra: ayardaki koleksiyonun ürün sırası (handle → sıra) */
    var order = {};
    String(cfg.order || '').split(',').forEach(function (handle, i) {
      handle = handle.trim();
      if (handle && !has(order, handle)) order[handle] = i;
    });

    var QUESTIONS = (cfg.questions || [])
      .map(function (q) {
        return { key: q.key, title: q.title, short: q.short || '', options: parseOptions(q.options) };
      })
      .filter(function (q) { return q.title && q.options.length; });

    var RANKS = [T.rankFirst, T.rankThen, T.rankBeside];

    var products = [];
    var step = 0;
    var answers = {}; /* soru anahtarı → etiket değeri */
    var labels = {}; /* soru anahtarı → görünen ad */
    var picked = {}; /* soru anahtarı → seçenek sırası */
    var touched = false; /* ilk çizimde odak taşınmaz, sayfa kendi kendine kaymaz */
    var inCart = false; /* sepette ürün var: "Sepete git" satırı kalıcıdır */
    var cartCount = 0;
    var inCartIds = {}; /* sepetteki varyant kimlikleri: kartta "Sepette", toplu düğmeye katılmaz */
    var found = []; /* son sonuç listesi (sepet değişince düğmeler yeniden kurulur) */

    /* Konu adları: kartta kitabın konuları yazılır (ürün etiketi → 2. sorunun seçenek adı) */
    var TOPICS = [];
    QUESTIONS.forEach(function (q) {
      if (q.key !== 'tema') return;
      q.options.forEach(function (o) {
        if (o.value) TOPICS.push(o);
      });
    });

    function formatMoney(cents) {
      return money(cents, cfg.moneyFormat);
    }

    function announce(message) {
      if (live) live.textContent = message || '';
    }

    /* ---- Veri ---- */
    function normalize(list) {
      return list
        .filter(function (p) {
          return p && p.variant && p.image && Array.isArray(p.tags) && p.tags.indexOf(appTag) === -1;
        })
        .map(function (p) {
          p.set = hasAny(p, SET_TAGS);
          p.key = wordKey(p.title);
          p.hay = p.set ? ' ' + wordKey(p.title + ' ' + plain(p.inside)) + ' ' : '';
          /* Setin kitapları (custom.set_icerigi satırları, " | " ile): iki setin ortak kitabı var mı */
          p.members = p.set ? String(p.inside || '').split('|').map(function (x) { return wordKey(x); }).filter(Boolean) : [];
          p.span = ageSpan(p.age);
          p.series = wordKey(p.series);
          p.format = wordKey(p.format);
          p.kit = (p.tags || []).indexOf('tip-set') !== -1; /* "Set" etiketi (rs-card ile aynı kural) */
          p.order = has(order, p.handle) ? order[p.handle] : 1e6;
          return p;
        });
    }

    function fromEmbedded() {
      var list = readJson(root.querySelector('[data-rs-finder-products]'));
      if (!Array.isArray(list)) return [];
      return normalize(
        list.map(function (p) {
          p.price = Number(p.price) || 0;
          p.compare = Number(p.compare) || 0;
          p.summary = summarize(p.summary);
          return p;
        })
      );
    }

    /* Yedek yol: gömülü liste boşsa eski bölümün kullandığı uç okunur */
    function fromStorefront() {
      return fetch(cfg.productsUrl || '/collections/all/products.json?limit=250')
        .then(function (response) {
          if (!response.ok) throw new Error('load-failed');
          return response.json();
        })
        .then(function (data) {
          return normalize(
            (data.products || []).map(function (p) {
              var v = p.variants && p.variants[0];
              var price = v ? Math.round(parseFloat(v.price) * 100) : 0;
              var compare = v && v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0;
              return {
                handle: p.handle,
                title: p.title,
                url: '/products/' + p.handle,
                tags: p.tags || [],
                price: price,
                compare: compare > price ? compare : 0,
                variant: v ? v.id : null,
                available: v ? v.available : false,
                image: p.images && p.images[0] ? p.images[0].src : '',
                tint: '',
                age: '',
                summary: '',
                series: '',
                format: '',
                inside: '',
                kind: '',
              };
            })
          );
        });
    }

    /* ---- Adımlar: "Kendim için" seçilince konu sorusu atlanır ---- */
    function isParent() {
      var tags = tagList(answers.yas);
      return tags.length > 0 && tags.every(function (t) { return t === PARENT_TAG; });
    }

    function skipped(index) {
      return !!QUESTIONS[index] && QUESTIONS[index].key === 'tema' && isParent();
    }

    function activeSteps() {
      var list = [];
      QUESTIONS.forEach(function (q, i) {
        if (!skipped(i)) list.push(i);
      });
      return list;
    }

    function nextStep(from) {
      var i = from + 1;
      while (i < QUESTIONS.length && skipped(i)) i += 1;
      return i;
    }

    function prevStep(from) {
      var i = from - 1;
      while (i > 0 && skipped(i)) i -= 1;
      return Math.max(0, i);
    }

    function isComplete() {
      return QUESTIONS.every(function (q, i) { return skipped(i) || has(labels, q.key); });
    }

    function forgetAnswer(key) {
      delete answers[key];
      delete labels[key];
      delete picked[key];
    }

    /* ---- Yanıtları saklama ---- */
    function save() {
      try {
        var choice = {};
        QUESTIONS.forEach(function (q) {
          if (has(picked, q.key)) choice[q.key] = [picked[q.key], labels[q.key]];
        });
        window.sessionStorage.setItem(storeKey, JSON.stringify({ t: Date.now(), step: step, picked: choice }));
      } catch (error) {
        /* gizli sekme ya da kapalı depolama: yanıtlar yalnız bu sayfada yaşar */
      }
    }

    /* Saklanan yanıtlar bugünkü seçeneklerle birebir tutuyorsa geri yüklenir */
    function restore() {
      if (window.Shopify && window.Shopify.designMode) return false;
      var data = null;
      try {
        data = JSON.parse(window.sessionStorage.getItem(storeKey));
      } catch (error) {
        return false;
      }
      if (!data || typeof data !== 'object' || !data.picked || !(Date.now() - Number(data.t) < KEEP_MS)) return false;

      var a = {};
      var l = {};
      var p = {};
      var valid = true;
      QUESTIONS.forEach(function (q) {
        var entry = data.picked[q.key];
        if (!Array.isArray(entry)) return;
        var option = q.options[entry[0]];
        if (!option || option.label !== entry[1]) {
          valid = false;
          return;
        }
        a[q.key] = option.value;
        l[q.key] = option.label;
        p[q.key] = entry[0];
      });
      if (!valid || !Object.keys(l).length) return false;

      answers = a;
      labels = l;
      picked = p;
      if (isParent()) forgetAnswer('tema');
      step = Math.min(Math.max(parseInt(data.step, 10) || 0, 0), QUESTIONS.length);
      if (step === QUESTIONS.length && !isComplete()) {
        step = 0;
        while (step < QUESTIONS.length && (skipped(step) || has(labels, QUESTIONS[step].key))) step += 1;
      } else if (step < QUESTIONS.length && skipped(step)) {
        step = nextStep(step);
      }
      return true;
    }

    /* ---- Puanlama ---- */
    /* "4–8 yaş" → [4, 8]; okunamazsa null */
    function ageSpan(text) {
      var m = String(text || '').match(/(\d+)\D+(\d+)/);
      return m ? [parseInt(m[1], 10), parseInt(m[2], 10)] : null;
    }

    /* Ürünün yaş aralığının ne kadarı seçilen yaşın (etiketlerden: yas-8-9, yas-10-11) içinde;
       dörtte birlik basamaklara yuvarlanır ki koleksiyon sırası anlamını korusun */
    function ageFit(product) {
      var tags = tagList(answers.yas);
      if (!tags.length || !product.span) return 0;
      var lo = 99, hi = -1;
      tags.forEach(function (t) {
        var m = String(t).match(/yas-(\d+)-(\d+)/);
        if (m) { lo = Math.min(lo, +m[1]); hi = Math.max(hi, +m[2]); }
      });
      if (hi < 0) return 0;
      var a = product.span[0], b = product.span[1];
      var inside = Math.max(0, Math.min(b, hi) - Math.max(a, lo) + 1);
      return Math.round((inside / (b - a + 1)) * 4) / 4;
    }

    function fit(product) {
      return {
        yas: !!answers.yas && hasAny(product, tagList(answers.yas)),
        tema: !!answers.tema && product.tags.indexOf(answers.tema) !== -1,
        butce: !!answers.butce && budgetFits(product, answers.butce, bands),
      };
    }

    /* Kesin kurallar: ikinci set alınmaz; bir set ile içindeki tek kitap yan yana gelmez */
    function clashes(x, chosen) {
      var p = x.product;
      return chosen.some(function (c) {
        var q = c.product;
        if (p.set && q.set) {
          if (answers.butce !== 'b3') return true;
          return p.members.some(function (m) { return q.members.indexOf(m) !== -1; });
        }
        if (q.set && !p.set) return holds(q, p);
        if (p.set && !q.set) return holds(p, q);
        return false;
      });
    }

    /* Aynı seri ya da aynı kalıp (yayınevi + ebat): seri alanı boş kitaplar da yakalanır */
    function sameSeries(x, chosen) {
      var series = x.product.series;
      var format = x.product.format;
      return chosen.some(function (c) {
        return (!!series && c.product.series === series) || (!!format && c.product.format === format);
      });
    }

    function choose(sorted) {
      var out = [];
      var rest = sorted.slice();
      var spare = [];
      while (out.length < limit && rest.length) {
        var first = rest[0];
        if (clashes(first, out)) {
          spare.push(rest.shift());
          continue;
        }
        var at = 0;
        /* Konu eşleşmesi yokken çeşitlilik: aynı puanda başka seriden kitap varsa o alınır */
        if (!first.fit.tema && sameSeries(first, out)) {
          for (var i = 1; i < rest.length && rest[i].score === first.score; i += 1) {
            if (!!rest[i].over === !!first.over && !sameSeries(rest[i], out) && !clashes(rest[i], out)) {
              at = i;
              break;
            }
          }
        }
        out.push(rest.splice(at, 1)[0]);
      }
      /* Kurallar listeyi eksik bıraktıysa ayrılan tek kitaplarla tamamlanır */
      for (var j = 0; out.length < limit && j < spare.length; j += 1) {
        if (!spare[j].product.set) out.push(spare[j]);
      }
      return out;
    }

    function rank() {
      var gate = tagList(answers.yas).length > 0;
      var pool = products
        .map(function (product) {
          var f = fit(product);
          return {
            product: product,
            fit: f,
            score: (f.yas ? 5 : 0) + (f.tema ? 4 : 0) + (f.butce ? 2 : 0),
            over: budgetOver(product, answers.butce, bands),
          };
        })
        .filter(function (x) { return gate ? x.fit.yas : x.score > 0; })
        .sort(function (a, b) {
          return (
            b.score - a.score ||
            a.over - b.over ||
            ageFit(b.product) - ageFit(a.product) ||
            a.product.order - b.product.order ||
            a.product.price - b.product.price
          );
        });
      return withinBudget(choose(pool), pool);
    }

    /* Bütçe sorulduysa ve bütçeye uyan kitap varsa listede en az biri bulunur: konu uğruna
       hepsi bütçe üstü bir liste, "150 TL'ye kadar" diyen kullanıcıyla çelişir. Konu yine
       önce gelir: bütçeye uyan kitap (konusu tutmasa da) listenin sonuna eklenir ve not
       bunu söyler. */
    function withinBudget(out, pool) {
      if (answers.butce !== 'b1' && answers.butce !== 'b2') return out;
      if (!out.some(function (x) { return !x.over; })) {
        /* Liste doluysa sonuncunun yerine geçer; yer varsa hiçbir kitap düşmez */
        var keep = out.length < limit ? out.slice() : out.slice(0, Math.max(0, limit - 1));
        var spare = pool.filter(function (x) {
          return !x.over && out.indexOf(x) === -1 && !clashes(x, keep);
        })[0];
        if (!spare) return out;
        out = keep.concat(spare);
      }
      return out;
    }

    /* Yaş ve konu karolarında canlı sayaç. Konu sayacı seçilen yaşla sınırlıdır.
       Sayaç tutulmayan seçenekte (ör. "Emin değilim") null döner. */
    function countFor(question, option) {
      if (!option.value || (question.key !== 'yas' && question.key !== 'tema')) return null;
      var tags = tagList(option.value);
      var pool = products;
      if (question.key === 'tema') {
        var age = tagList(answers.yas);
        if (age.length) pool = pool.filter(function (p) { return hasAny(p, age); });
      }
      return pool.filter(function (p) { return hasAny(p, tags); }).length;
    }

    /* ---- Çizim ---- */
    function drawSteps() {
      if (!stepsEl) return;
      stepsEl.innerHTML = activeSteps().map(function (i, n) {
        var q = QUESTIONS[i];
        var answered = has(labels, q.key);
        var current = i === step;
        var text = answered ? labels[q.key] : q.short;
        var inner =
          '<i aria-hidden="true">' + (answered && !current ? '✓' : n + 1) + '</i>' +
          (text ? '<span>' + esc(text) + '</span>' : '');
        if (answered && !current) {
          var name = (q.short ? q.short + ': ' : '') + labels[q.key] + ', ' + (T.change || '');
          /* Kalem simgesi: yanıtın değiştirilebileceği görünür olsun (dokunmatikte hover yok) */
          return (
            '<li class="rs-finder__step is-done">' +
            '<button type="button" class="rs-finder__stepin" data-rs-finder-step="' + i + '" aria-label="' + esc(name) + '">' +
            inner + '<b class="rs-finder__edit" aria-hidden="true"></b>' +
            '</button></li>'
          );
        }
        return (
          '<li class="rs-finder__step' + (current ? ' is-on' : '') + '">' +
          '<span class="rs-finder__stepin"' + (current ? ' aria-current="step"' : '') + '>' + inner + '</span></li>'
        );
      }).join('');
    }

    function show(html) {
      screen.innerHTML = html;
      /* İlk çizim sunucunun bastığı soruyu sessizce değiştirir: giriş canlandırması oynamaz */
      if (!touched) {
        var pane = screen.firstElementChild;
        if (pane) pane.classList.add('is-static');
        return;
      }
      var target = screen.querySelector('[data-rs-finder-focus]');
      if (!target) return;
      target.focus({ preventScroll: true });
      var box = card.getBoundingClientRect();
      var seen = target.getBoundingClientRect();
      if (box.top < 0 || seen.bottom > window.innerHeight) {
        card.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }

    /* Masaüstünde sonuç kartı ilk ekrana sığmaz: fiyat ve sepet düğmeleri görünsün diye
       sayfa, yanıt çipleri en üstte kalacak kadar kayar (çipler yanıt değiştirmenin yoludur). */
    function revealResults() {
      if (!touched || !stepsEl || !window.matchMedia || !window.matchMedia('(min-width: 990px)').matches) return;
      if (card.getBoundingClientRect().bottom <= window.innerHeight) return;
      stepsEl.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    function absoluteUrl(product) {
      var path = product.url || '/products/' + product.handle;
      try {
        return new URL(path, window.location.origin).href;
      } catch (error) {
        return path;
      }
    }

    function showMail(found) {
      if (!mail) return;
      mail.hidden = !found;
      if (!found) return;
      /* Yaşa göre bülten: seçilen yaş etiketleri müşteriye yazılır (segment) */
      var tags = mail.querySelector('[data-rs-finder-mailtags]');
      if (tags) tags.value = ['newsletter', 'kitap-onerisi'].concat(tagList(answers.yas)).join(',');
      var note = mail.querySelector('[data-rs-finder-mailnote]');
      if (note) {
        note.value = found
          .map(function (x, i) {
            return i + 1 + '. ' + x.product.title + ' · ' + formatMoney(x.product.price) + ' · ' + absoluteUrl(x.product);
          })
          .join(' | ');
      }
    }

    function drawQuestion() {
      var q = QUESTIONS[step];
      var active = activeSteps();
      var stepText = fill(T.step, { step: active.indexOf(step) + 1, total: active.length });
      var headingId = uid + '-q';
      var ageChosen = tagList(answers.yas).length > 0;

      /* Seçilen yaşta kitabı olmayan konu karosu yerinde soluk durur. Konuların yarısı ya da
         fazlası boşsa (ör. 8 yaş ve üstü) ızgara yarı ölü görünüyordu: boş konular karolardan
         çıkar, altta tek satırda sayılır. */
      var rows = q.options.map(function (o, i) {
        var count = countFor(q, o);
        return { o: o, i: i, count: count, off: q.key === 'tema' && ageChosen && count === 0 };
      });
      var offRows = rows.filter(function (r) { return r.off; });
      var folded = offRows.length > 0 && offRows.length * 2 >= rows.length && !!T.topicsClosed;
      var shown = folded ? rows.filter(function (r) { return !r.off; }) : rows;
      var n = shown.length;
      var cols = n <= 4 ? n : n <= 6 ? 3 : 4;

      root.classList.remove('is-results');
      showMail(null);
      show(
        '<div class="rs-finder__pane">' +
          '<p class="rs-kicker">' + esc(stepText) + '</p>' +
          '<h2 class="rs-finder__q" id="' + headingId + '" tabindex="-1" data-rs-finder-focus>' + esc(q.title) + '</h2>' +
          '<div class="rs-finder__tiles" role="group" aria-labelledby="' + headingId + '" style="--cols:' + cols + '">' +
          shown
            .map(function (r) {
              var o = r.o;
              var i = r.i;
              var count = r.count;
              var on = picked[q.key] === i;
              /* Seçilen yaşta bu konuda kitap yoksa karo kapalı görünür ve seçilmez */
              var off = r.off;
              var countText = off ? T.topicNone : count ? fill(T.count, { count: count }) : '';
              var sub = [o.note, countText].filter(Boolean).join(' · ');
              return (
                '<button type="button" class="rs-finder__tile' + (on ? ' is-on' : '') + (off ? ' is-off' : '') + '"' +
                ' data-rs-finder-option="' + i + '" aria-pressed="' + on + '"' + (off ? ' aria-disabled="true"' : '') + '>' +
                '<b>' + esc(o.label) + '</b>' +
                (sub ? '<small>' + esc(sub) + '</small>' : '') +
                '</button>'
              );
            })
            .join('') +
          '</div>' +
          (folded
            ? '<p class="rs-finder__closed">' +
              esc(fill(T.topicsClosed, { list: offRows.map(function (r) { return r.o.label; }).join(', ') })) +
              '</p>'
            : '') +
          (step > 0
            ? '<button type="button" class="rs-finder__back" data-rs-finder-back><span aria-hidden="true">←</span> ' + esc(T.back) + '</button>'
            : '') +
        '</div>'
      );
      announce(touched ? stepText : '');
    }

    /* "Baştan başla" geri alma eylemidir: birincil düğmeyle yarışmasın diye metin bağlantısı */
    function restartButton() {
      return (
        '<button type="button" class="rs-finder__restart" data-rs-finder-restart>' +
        '<span aria-hidden="true">↺</span> ' + esc(T.restart) +
        '</button>'
      );
    }

    /* Kitabın konuları (2. sorunun adlarıyla); seçilen konu başta ve işaretli. Her kartta
       aynı olan "Seçiminizle eşleşen" satırının yerine: kitabı birbirinden ayıran bilgi. */
    function topicsHtml(p) {
      var list = TOPICS.filter(function (o) { return p.tags.indexOf(o.value) !== -1; });
      if (!list.length) return '';
      list.sort(function (a, b) { return (b.value === answers.tema) - (a.value === answers.tema); });
      return (
        '<ul class="rs-finder__topics">' +
        list
          .map(function (o) {
            var hit = o.value === answers.tema;
            return '<li' + (hit ? ' class="is-hit"' : '') + '>' + (hit ? '<span aria-hidden="true">✓ </span>' : '') + esc(o.label) + '</li>';
          })
          .join('') +
        '</ul>'
      );
    }

    /* Kapak: düz kapak dosyası rs-kitap iskeletiyle (sırt, sayfa bloğu, arka kapak) basılır;
       ölçüler Liquid'den gelir (snippets/rs-kitap ile aynı hesap). Fotoğraf yalnız gölge alır. */
    function coverHtml(p) {
      var srcset = [240, 480, 720].map(function (w) { return esc(sized(p.image, w)) + ' ' + w + 'w'; }).join(', ');
      var img = function (cls) {
        return (
          '<img' + (cls ? ' class="' + cls + '"' : '') + ' src="' + esc(sized(p.image, 480)) + '" srcset="' + srcset + '"' +
          ' sizes="(min-width: 990px) 300px, (min-width: 750px) 140px, 100px" alt="" loading="lazy" decoding="async">'
        );
      };
      if (p.kind === 'kapak' && SAFE_NUM.test(String(p.ar)) && SAFE_NUM.test(String(p.tw))) {
        var stage = SAFE_COLOR.test(p.stage || '') ? ';--rs-stage:' + p.stage : '';
        return (
          '<span class="rs-kitap rs-kitap--kart' + (p.karton ? ' rs-kitap--karton' : '') + '" style="--ar:' + p.ar + ';--tw:' + p.tw + stage + '">' +
            '<span class="rs-kitap__govde">' +
              '<span class="rs-kitap__arka" aria-hidden="true"></span>' +
              '<span class="rs-kitap__sayfa" aria-hidden="true"></span>' +
              '<span class="rs-kitap__on">' + img('') + '</span>' +
            '</span>' +
          '</span>'
        );
      }
      return img(p.kind === 'foto' ? 'rs-gorsel rs-gorsel--foto' : '');
    }

    function overText(x) {
      if (!(x.over > 0) || !T.overBudget) return '';
      return fill(T.overBudget, { fark: formatMoney(x.over) });
    }

    /* Fiyat satırının sağı: sepette değilse ikincil "Sepete ekle", sepetteyse işaret */
    function addHtml(p) {
      if (!p.available) return '<span class="rs-finder__out">' + esc(T.soldOut) + '</span>';
      if (inCartIds[p.variant]) {
        return '<span class="rs-finder__inbag" tabindex="-1"><span aria-hidden="true">✓</span> ' + esc(T.inCartChip || T.added) + '</span>';
      }
      return (
        '<button type="button" class="rs-btn rs-btn--line rs-finder__add"' +
        ' data-op-add="' + esc(p.variant) + '"' +
        ' data-op-adding="' + esc(T.adding) + '"' +
        ' data-op-added="' + esc(T.added) + '"' +
        ' data-op-error="' + esc(T.addError) + '"' +
        ' aria-label="' + esc(p.title + ': ' + T.add) + '">' +
        esc(T.add) +
        '</button>'
      );
    }

    function bookHtml(x, i) {
      var p = x.product;
      var rankText = RANKS[i] || T.rankAlso || '';
      var tint = SAFE_COLOR.test(p.tint || '') ? ' style="--rs-tint:' + p.tint + '"' : '';
      /* "Kendim için" listesinde çocuk yaş aralığı yazılmaz (ortak etiketli ürünler) */
      var age = isParent() && /\d/.test(p.age || '') ? '' : p.age;
      /* Set, sitenin her yerindeki gibi "Set ·" önekiyle (rs-card ile aynı kural) */
      var meta = [p.kit ? 'Set' : '', age].filter(Boolean).join(' · ');
      var over = overText(x);

      return (
        '<li><article class="rs-finder__book" data-rs-finder-variant="' + esc(p.variant) + '"' + tint + '>' +
          '<a class="rs-finder__well" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + coverHtml(p) + '</a>' +
          '<div class="rs-finder__info">' +
            '<p class="rs-finder__rank">' + esc(rankText) + (meta ? ' <span>· ' + esc(meta) + '</span>' : '') + '</p>' +
            '<h3><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
            topicsHtml(p) +
            (p.summary ? '<p class="rs-finder__sum">' + esc(p.summary) + '</p>' : '') +
            (over ? '<p class="rs-finder__over">' + esc(over) + '</p>' : '') +
            '<div class="rs-finder__foot">' +
              '<span class="rs-finder__price">' +
                '<b>' + esc(formatMoney(p.price)) + '</b>' +
                (p.compare > p.price ? '<s>' + esc(formatMoney(p.compare)) + '</s>' : '') +
              '</span>' +
              addHtml(p) +
            '</div>' +
          '</div>' +
        '</article></li>'
      );
    }

    /* ---- Toplu düğme: bütçeye uyar, sepettekileri bir daha eklemez ---- */
    function bulkPlan() {
      if (!cfg.bulk || answers.butce === 'b1') return null;
      if (found.some(function (x) { return x.product.set; })) return null;
      var spent = 0;
      found.forEach(function (x) {
        if (inCartIds[x.product.variant]) spent += x.product.price;
      });
      var cap = answers.butce === 'b2' ? bands.b2 * 100 : Infinity;
      var list = found.filter(function (x) {
        var p = x.product;
        if (!p.available || inCartIds[p.variant]) return false;
        if (answers.butce === 'b2' && (x.over || spent + p.price > cap)) return false;
        spent += p.price;
        return true;
      });
      if (list.length < 2) return null;
      var label = T.addAll;
      if (list.length < found.length) {
        var rest = found.some(function (x) { return inCartIds[x.product.variant]; });
        label = fill(rest ? T.bulkRest : T.bulkSome, { count: list.length }) || T.addAll;
      }
      return {
        ids: list.map(function (x) { return x.product.variant; }).join(','),
        total: list.reduce(function (sum, x) { return sum + x.product.price; }, 0),
        label: label,
      };
    }

    /* Sonuçların altı: sepet satırı (sepette ürün varsa) + toplu düğme + "Baştan başla".
       Birincil (dolu) düğme tektir: sepet doluyken "Sepete git", boşken toplu düğme. */
    function afterHtml() {
      var plan = bulkPlan();
      var row = '';
      if (inCart && T.goCart) {
        var text = fill(T.inCart, { count: cartCount > 0 ? cartCount : '' }).replace(/\s+/g, ' ').trim();
        row =
          '<div class="rs-finder__incart" data-rs-finder-incart>' +
            '<p><span aria-hidden="true">✓</span> ' + esc(text) + '</p>' +
            '<a class="rs-btn" href="' + esc(cartUrl) + '">' + esc(T.goCart) + '</a>' +
          '</div>';
      }
      var bulk = plan
        ? '<button type="button" class="rs-btn' + (row ? ' rs-btn--line' : '') + '"' +
          ' data-op-add-many="' + esc(plan.ids) + '"' +
          ' data-op-adding="' + esc(T.adding) + '"' +
          ' data-op-added="' + esc(T.added) + '"' +
          ' data-op-error="' + esc(T.addError) + '">' +
          esc(plan.label + ' · ' + formatMoney(plan.total)) +
          '</button>'
        : '';
      return row + '<div class="rs-finder__actions">' + bulk + restartButton() + '</div>';
    }

    /* Sepet değişince sonuç ekranı yeniden çizilmez (odak ve kaydırma yerinde kalır):
       yalnız kartların düğmeleri ve alt bölüm yenilenir. */
    function syncCart() {
      if (!root.classList.contains('is-results')) return;
      var focused = document.activeElement;
      var refocus = null;
      Array.prototype.forEach.call(screen.querySelectorAll('[data-rs-finder-variant]'), function (book) {
        var id = book.getAttribute('data-rs-finder-variant');
        var button = book.querySelector('.rs-finder__add');
        if (!button || !inCartIds[id]) return;
        var x = found.filter(function (f) { return String(f.product.variant) === id; })[0];
        if (!x) return;
        var holder = document.createElement('span');
        holder.innerHTML = addHtml(x.product);
        var mark = holder.firstChild;
        button.parentNode.replaceChild(mark, button);
        if (focused === button) refocus = mark;
      });
      var after = screen.querySelector('[data-rs-finder-after]');
      if (after) {
        var hadFocus = after.contains(focused);
        after.innerHTML = afterHtml();
        if (hadFocus) refocus = after.querySelector('.rs-finder__incart a') || after.querySelector('button');
      }
      if (refocus) refocus.focus({ preventScroll: true });
    }

    var cartSeen = false; /* sepet bir kez okunduysa ya da 'op:cart' geldiyse yeniden çekilmez */
    /* Geri tuşuyla (bfcache) dönülünce sepet başka sayfada değişmiş olabilir */
    window.addEventListener('pageshow', function (event) { if (event.persisted) cartSeen = false; });
    function applyCart(cart) {
      if (!cart || typeof cart.item_count !== 'number') return;
      cartSeen = true;
      cartCount = cart.item_count;
      inCart = cartCount > 0;
      inCartIds = {};
      (cart.items || []).forEach(function (item) { inCartIds[item.variant_id] = true; });
    }

    /* Yalnız sonuç ekranı çizilirken (önceki ziyaretten sepette kalanlar için) */
    function readCart() {
      if (cartSeen) return Promise.resolve();
      return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(applyCart)
        .catch(function () {
          /* sepet okunamadıysa düğmeler olduğu gibi kalır, satır sayısız yazılır */
        });
    }

    function drawResults() {
      found = rank();

      if (!found.length) {
        root.classList.remove('is-results');
        showMail(null);
        show(
          '<div class="rs-finder__pane rs-finder__pane--empty">' +
            '<h2 class="rs-finder__q" tabindex="-1" data-rs-finder-focus>' + esc(T.emptyTitle) + '</h2>' +
            '<p class="rs-finder__text">' + esc(T.emptyText) + '</p>' +
            '<div class="rs-finder__actions">' + restartButton() + '</div>' +
          '</div>'
        );
        announce(T.emptyText);
        return;
      }

      /* Dürüst başlık: konu tutmadıysa, bütçeye uyan kitap hiç yoksa ya da o yaşta set
         yoksa açıkça söylenir */
      var topicAsked = !!answers.tema;
      var topicHit = found.some(function (x) { return x.fit.tema; });
      var hasSet = found.some(function (x) { return x.product.set; });
      var budgetAsked = answers.butce === 'b1' || answers.butce === 'b2';
      var allOver = budgetAsked && found.every(function (x) { return x.over > 0; });
      var notices = [];
      if (topicAsked && !topicHit && T.noTopic) notices.push(T.noTopic);
      var limitText = formatMoney((answers.butce === 'b1' ? bands.b1 : bands.b2) * 100);
      if (allOver && T.noBudget) {
        notices.push(fill(T.noBudget, { limit: limitText }));
      } else if (budgetAsked && topicHit && T.budgetTopic && !found.some(function (x) { return x.fit.tema && !x.over; })) {
        /* Konudaki kitapların hepsi bütçe üstü; bütçeye uyan başka konudan bir kitap eklendi */
        notices.push(fill(T.budgetTopic, { limit: limitText }));
      }
      if (answers.butce === 'b3' && !hasSet && T.noSet) notices.push(T.noSet);

      /* Tek kitap bütçesinde liste bir seçenek kümesidir ("bu üç kitapla başlayın" değil) */
      var heading = answers.butce === 'b1' && T.resultsHeadingOne ? T.resultsHeadingOne : T.resultsHeading;

      root.classList.add('is-results');
      show(
        '<div class="rs-finder__pane rs-finder__pane--results">' +
          '<div class="rs-finder__rhead">' +
            '<h2 class="rs-finder__q" tabindex="-1" data-rs-finder-focus>' + esc(fill(heading, { count: found.length })) + '</h2>' +
            (topicAsked && topicHit && !allOver && T.resultsText ? '<p class="rs-finder__text">' + esc(T.resultsText) + '</p>' : '') +
            notices.map(function (text) { return '<p class="rs-finder__notice">' + esc(text) + '</p>'; }).join('') +
          '</div>' +
          '<ol class="rs-finder__results" style="--cols:' + (found.length === 4 ? 4 : Math.min(found.length, 3)) + '">' +
            found.map(bookHtml).join('') +
          '</ol>' +
          '<div class="rs-finder__after" data-rs-finder-after>' + afterHtml() + '</div>' +
        '</div>'
      );
      showMail(found);
      revealResults();
      announce(
        notices
          .concat(found.map(function (x, i) { return (RANKS[i] || T.rankAlso || '') + ': ' + x.product.title + '.'; }))
          .join(' ')
      );
      /* Sepette olan kitaplar "Sepette" olarak işaretlenir (önceki ziyaretten kalanlar dahil) */
      readCart().then(syncCart);
    }

    function draw() {
      drawSteps();
      if (step < QUESTIONS.length) {
        drawQuestion();
      } else {
        drawResults();
      }
      save();
    }

    /* ---- Etkileşim ---- */
    root.addEventListener('click', function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      var option = target.closest('[data-rs-finder-option]');
      if (option && step < QUESTIONS.length) {
        if (option.getAttribute('aria-disabled') === 'true') return;
        var q = QUESTIONS[step];
        var index = Number(option.getAttribute('data-rs-finder-option'));
        var chosen = q.options[index];
        if (!chosen) return;
        answers[q.key] = chosen.value;
        labels[q.key] = chosen.label;
        picked[q.key] = index;
        /* Ebeveyn kitaplarında konu etiketi yok: konu yanıtı silinir, adım atlanır */
        if (isParent()) forgetAnswer('tema');
        /* Sonuçtan dönüp tek yanıtı değiştiren, öbür adımları yeniden geçmez */
        step = isComplete() ? QUESTIONS.length : nextStep(step);
        touched = true;
        draw();
        return;
      }

      var jump = target.closest('[data-rs-finder-step]');
      if (jump) {
        step = Number(jump.getAttribute('data-rs-finder-step')) || 0;
        touched = true;
        draw();
        return;
      }

      if (target.closest('[data-rs-finder-back]')) {
        step = prevStep(step);
        touched = true;
        draw();
        return;
      }

      if (target.closest('[data-rs-finder-restart]')) {
        step = 0;
        answers = {};
        labels = {};
        picked = {};
        touched = true;
        draw();
      }
    });

    /* Sepete ekleme başarıyla bitti (assets/oyunperest.js): sepet okunur, düğmeler ve
       "Sepete git" satırı güncellenir. Sepet 'op:cart' olayıyla gelir; dinleyici dosyanın
       başında bir kez kurulur. */
    root.rsFinderOnCart = function (cart) {
      applyCart(cart);
      syncCart();
    };
    finders.push(root);

    /* ---- Öneriyi e-postayla isteme: sayfa yenilenmez, sonuçlar ekranda kalır ---- */
    if (mail) {
      /* Tarayıcı formu kendi gönderdiyse (doğrulama adımından dönüş) sonuç iletisi kartın başına taşınır */
      var flash = mail.querySelector('[data-rs-finder-flash]');
      if (flash) card.insertBefore(flash, card.firstChild);

      var form = mail.querySelector('[data-rs-finder-mailform]');
      var body = mail.querySelector('[data-rs-finder-mailbody]');
      if (form && body) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          var button = form.querySelector('[type="submit"]');
          var problem = form.querySelector('[data-rs-finder-mailerror]');
          var original = button ? button.textContent : '';
          if (problem) problem.hidden = true;
          if (button) {
            button.disabled = true;
            button.textContent = T.mailSending;
          }
          fetch(form.getAttribute('action') || window.location.pathname, {
            method: 'POST',
            body: new FormData(form),
          })
            .then(function (response) {
              if (!response.ok) throw new Error('mail-failed');
              /* Shopify robot doğrulaması isterse form tarayıcıyla gönderilir */
              if (response.redirected && /\/challenge/.test(response.url)) {
                form.submit();
                return;
              }
              body.innerHTML = '<p class="rs-finder__mailhelp" role="status">' + esc(T.mailSuccess) + '</p>';
            })
            .catch(function () {
              if (button) {
                button.disabled = false;
                button.textContent = original;
              }
              if (problem) {
                problem.textContent = T.mailError;
                problem.hidden = false;
              }
            });
        });
      }
    }

    /* ---- Başlangıç ---- */
    /* Başka sayfadan yaş seçili gelinebilir (hediye sayfası: /pages/oneri?yas=yas-0-3):
       o etiketi taşıyan seçenek seçilir, konu sorusundan başlanır */
    function fromLink() {
      var tag = '';
      try {
        tag = new URLSearchParams(window.location.search).get('yas') || '';
      } catch (error) {
        return false;
      }
      var q = QUESTIONS[0];
      if (!tag || !q || q.key !== 'yas') return false;
      var index = -1;
      q.options.forEach(function (o, i) {
        if (index === -1 && tagList(o.value).indexOf(tag) !== -1) index = i;
      });
      if (index === -1) return false;
      answers.yas = q.options[index].value;
      labels.yas = q.options[index].label;
      picked.yas = index;
      step = nextStep(0);
      return true;
    }

    function start() {
      /* Bağlantıyla gelen yaş önceliklidir; yoksa saklanan yanıtlar varsa kaldığı yerden.
         Odak taşınmaz, sayfa kaymaz. Sepet, sonuç ekranı her çizildiğinde okunur. */
      if (!fromLink()) restore();
      draw();
    }

    products = fromEmbedded();
    if (products.length) {
      start();
      return;
    }
    drawSteps();
    screen.innerHTML = '<p class="rs-finder__wait">' + esc(T.loading) + '</p>';
    fromStorefront()
      .then(function (list) {
        products = list;
        start();
      })
      .catch(function () {
        screen.innerHTML = '<p class="rs-finder__wait" role="alert">' + esc(T.loadError) + '</p>';
      });
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-rs-finder]'), init);
  }

  boot(document);
  /* Tema düzenleyicisi bölümü yeniden çizdiğinde */
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
